import { Component, Inject } from '@angular/core'
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { CommonModule } from '@angular/common'
import { Player } from '../../../../../core/models/player.model'
import { LineupService } from '../../../services/lineup.service'
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete'
import { PlayerService } from 'src/app/core/services/player.service'
import { MatIconModule } from '@angular/material/icon'

@Component({
    selector: 'player-price-dialog',
    templateUrl: 'player-price-dialog.component.html',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        CommonModule,
        MatIconModule,
        MatAutocompleteModule,
        ReactiveFormsModule
    ],
    styleUrl: './player-price-dialog.component.css'
  })
  export class PlayerPriceDialog{
    constructor(
        public service: LineupService,
        public playerService:PlayerService, 
        public dialogRef: MatDialogRef<PlayerPriceDialog>,
        @Inject(MAT_DIALOG_DATA) public data: Player
    ) {}

    submit(){
        if(this.service.priceForm.valid)
        this.dialogRef.close()
    }

    players:Player[] = []
    filteredPlayers:Player[] = []
    private debounceTimeout: any

    filter(inputElement: HTMLInputElement) {
        clearTimeout(this.debounceTimeout)
        const inputValue = inputElement.value.toLowerCase()
        this.debounceTimeout = setTimeout(() => {
            if(inputValue.length > 1)
            this.playerService.fetchPlayers(inputValue, '').subscribe(players=>{
                this.filteredPlayers = players as Player[]
            })
        }, 300)
    }

    displayFn(value: Player) {
        if(value) return value.name
        else return ""
    }

    onPlayerSelected(input: HTMLInputElement) {
        setTimeout(() => input.blur(), 100)
    }
}